import React from "react";
import { Box, CircularProgress, Divider, FormControlLabel, Switch, Typography } from "@material-ui/core";
import { useCreativeHistory } from "hooks/api/useCreativeHistory";
import { AltStepper, BoxContainer, Button, LoadingOverlay } from "components";
import { useSelector } from "react-redux";
import { getMaterialDetailsById } from "store/features/materialSpecs/specs";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import BasicHeader from "pages/MaterialSpecs/components/BasicHeader/BasicHeader";
import { useTranslation } from "react-i18next";
import { HistoryItem } from "pages/MaterialSpecs/components/InfoPanel/History/HistoryItem/HistoryItem";

export const History = () => {
    const { t } = useTranslation();
    const { selectedMaterialSpecId, selectedMaterialId } = useMaterialSpecs();
    const { isFetching, data: creativesHistoryPages, fetchMore, canFetchMore, isFetchingMore } = useCreativeHistory(
        selectedMaterialSpecId,
        selectedMaterialId
    );
    const materialDetails = useSelector(getMaterialDetailsById(selectedMaterialSpecId, selectedMaterialId));

    if (!materialDetails) {
        return null;
    }

    return (
        <LoadingOverlay height="auto" active={isFetching}>
            <Box position="relative">
                <Box width="100%" pt={2} position="sticky" top="0" bgcolor="white" zIndex={1}>
                    <BasicHeader
                        bookedDimensions={materialDetails.bookedSize}
                        modificationDate={materialDetails.modificationDate}
                        dimensions={materialDetails.dimensions}
                    />
                    <FormControlLabel
                        control={<Switch color="primary" />}
                        label={
                            <Typography variant="subtitle2" color="textSecondary">
                                <Box fontWeight="fontWeightBold">{t("campaign.history.label.showSystem")}</Box>
                            </Typography>
                        }
                    />
                    <Divider />
                </Box>
                {creativesHistoryPages?.map((historyPage) => {
                    return historyPage.page.map(({ date, history: historicalChanges }) => {
                        return (
                            <BoxContainer key={date} spacing={0.5} title={date}>
                                <AltStepper orientation="vertical">
                                    {historicalChanges.map(({ id, audits, status, source, endTime, user }) => {
                                        return (
                                            <HistoryItem
                                                key={id}
                                                historyId={id}
                                                audits={audits}
                                                status={status}
                                                source={source}
                                                endTime={endTime}
                                                user={user}
                                            />
                                        );
                                    })}
                                </AltStepper>
                            </BoxContainer>
                        );
                    });
                })}
            </Box>
            {canFetchMore && (
                <Box p={1} display="flex" flex={1} alignItems="center" justifyContent="center">
                    {isFetchingMore ? (
                        <CircularProgress size={20} />
                    ) : (
                        <Button onClick={() => fetchMore()}>{t("buttons.label.showMore")}</Button>
                    )}
                </Box>
            )}
        </LoadingOverlay>
    );
};
